export default {
  SET_USER_NETWORK_SHARES: 'setUserNetworkShares',
}